import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackClickEvent } from '@src/telemetry/track'

interface TrackingMetaData {
  context: string
}

interface TrackEventProps {
  tracker?: string
  trackingMetaData?: TrackingMetaData
  onClick?: (event: { direction: string }) => void
}

export const useTrackEvents = (props: TrackEventProps) => {
  const trackEvent = (type: string) => {
    if (props.tracker) {
      trackClickEvent(TELEMETRY_EVENT_NAMES.BUTTON_CLICK, {
        trackGA: true,
        trackInternal: true,
        // @i18n-ignore
        category: 'navigation',
        action: type === 'next' ? 'click_carousel_right' : 'click_carousel_left',
        value: props.tracker,
        context: props.trackingMetaData?.context,
      })
    }

    if (props.onClick) {
      props.onClick({ direction: type })
    }
  }

  return {
    // @i18n-ignore
    trackNext: () => {
      trackEvent('next')
    },
    // @i18n-ignore
    trackPrev: () => {
      trackEvent('prev')
    },
  }
}
